const isFullAdmin = () => {
  try {
    const cached = JSON.parse(localStorage.getItem('adminData') || '{}');
    return (cached?.data?.userType || cached?.userType) !== 'SUB_ADMIN';
  } catch {
    return true;
  }
};

const getPerson = item => item?.user || item?.candidate || {};

const getStaffName = item => {
  const person = getPerson(item);
  const name = [person.firstName, person.lastName].filter(Boolean).join(' ');
  return name || person.fullName || '-';
};

const getCustomerName = item => {
  const bookingUser = item?.booking?.user;
  const bookingName = [bookingUser?.firstName, bookingUser?.lastName].filter(Boolean).join(' ');
  return item?.booking?.invoiceName || bookingName || item?.candidate?.fullName || '-';
};

const getAccountNo = item =>
  item?.beneAccNo ||
  item?.CREDITACC ||
  item?.user?.bankAccountNumber ||
  item?.candidate?.bankAccountNumber ||
  '-';

const getIfsc = item =>
  item?.beneIFSC || item?.IFSC || item?.user?.ifscCode || item?.candidate?.ifscCode || '-';

const getPaymentMode = item => item?.paymentMode || item?.TXNTYPE || '-';

const getStatus = item => item?.Status || item?.status || '-';

const getRefundAmount = item => {
  if (item?.refundAmount != null && item.refundAmount !== '') return item.refundAmount;
  if (item?.description === 'Payout Refund') return item.amount;
  return null;
};

const isPendingPayout = item => {
  const status = String(getStatus(item)).toLowerCase();
  const type = String(item?.type || '').toLowerCase();
  return status === 'pending' && type !== 'credit';
};

const canRefundPayout = item => isFullAdmin() && isPendingPayout(item);

export {
  canRefundPayout,
  getAccountNo,
  getCustomerName,
  getIfsc,
  getPaymentMode,
  getPerson,
  getRefundAmount,
  getStaffName,
  getStatus,
  isFullAdmin,
  isPendingPayout,
};
